export const l =
    {
        //通用
        dty: 'Dian Ti Yun',
        subtitle: "One-stop elevator safety management platform",
        smart_screen: 'Smart Screen',
        face: 'Face recognition',
        id: "ID",
        save: 'Save',
        save_success: 'Save successfully',
        confirm: 'Confirm',
        cancel: 'Cancel',
        create: 'Create',
        fresh: 'Fresh',
        add: 'Add',
        add_success: 'Added successfully',
        add_fail: 'Add failed',
        edit: 'Edit',
        edit_success: 'Edit successfully',
        edit_fail: 'Edit failed',
        delete: 'Delete',
        delete_success: 'Successfully deleted',
        delete_fail: 'Failed to delete',
        no_data: 'unfilled',
        no_specific_location: 'No specific location was selected',
        total_data: 'Total',
        unit1: "pieces",
        unit2: "￥",
        data: "Data",
        date: 'Date',
        warn: "Warning",
        continue: "Continue",
        success: "Success",
        fail: "Fail",
        open: 'Turn on',
        close: 'Turn off',
        check: 'Check',
        prompt: 'Prompt',
        yes: 'Yes',
        no: 'No',
        device_num: 'Device Num',
        close_f_notice: 'Turn off the fault message',
        file: "File",
        log: 'log',
        behavior: 'Behavior',
        none: 'None',
        //提示
        remark: 'Please enter username',
        remark1: 'Please enter Mob or username',
        remark2: 'Please enter password',
        remark3: 'Please enter mobile phone',
        remark03: 'Please enter Email ',
        remark4: 'Please enter the captcha',
        remark5: 'Please enter a new password',
        remark6: 'Please enter the new password again',
        remark7: 'Please enter the old password',
        remark8: 'Old password cannot be null',
        remark9: 'New password cannot be null',
        remark10: 'Please enter company or department',
        remark11: 'Please enter a valid phone number',
        remark12: 'The current phone number has been registered',
        remark13: 'The current username has been registered',
        remark14: 'Please enter a valid email',
        remark15: 'Recharge amount (￥)',
        remark16: 'Please enter the amount to be added',
        remark17: "Manufacturer account",
        remark18: 'Click “Confirm” button to top up',
        remark19: 'Please enter the community name',
        remark20: 'Detailed address is not filled',
        remark21: 'Detailed address like No. 37 Century Road…',
        remark22: 'Daily QR code refresh times',
        remark23: 'Default daily QR code refresh times, modifiable when the elevator permission is granted',
        remark24: 'Please fill completely',
        remark25: 'Whether to continue to upload and overwrite when the same file name exists?',
        remark26: 'Failed to upload the file. Only APK file can be uploaded',
        remark27: 'Please select city',
        remark28: '*Note: After the APK is uploaded successfully, the size and version number will be automatically synchronized to the database. Please modify the file name to "diantiyun.apk" before uploading',
        remark29: 'Failed to load',
        remark30: '*Note: The size, file name and path of the APK file uploaded here do not need to be filled in, but the skin version number must be set manually',
        remark31: 'Please fill in the pushed parameter',
        remark32: 'Please fill in the text description of the parameter',
        remark33: 'This item cannot be empty',
        remark34: 'Please fill in the field',
        remark35: 'Please fill in the text description of the field',
        remark36: 'The current mobile phone number has been registered',
        remark37: 'The current username has been registered',
        remark38: 'Please enter username',
        remark39: 'Please enter name',
        remark39_a: 'Please fill in the password',
        remark39_b: 'Please enter the password again',
        remark40: 'Please enter employee ID',
        remark14_c: 'The two passwords are inconsistent',
        remark41: 'Please enter mobile phone number',
        remark42: 'Please enter the owner’s name or phone number',
        remark43: 'Current community manager status',
        remark44: 'Please select building No. and unit No.',
        remark45: 'No floor selected',
        remark46: 'No expiry time selected',
        remark47: 'No building number and unit number selected',
        remark48: 'Expiry of access to the elevator',
        remark49: 'No scanning frequency max. entered',
        remark50: 'Number of daily scans',
        remark51: 'Daily QR code scanning frequency max. for taking the elevator',
        remark52: 'Add a QR code to take the elevator key',
        remark53: 'Sure to shift to property management in identity?',
        remark54: 'Sure to shift to a general owner in identity?',
        remark55: 'Sure to delete the owner’s current location info?',
        remark56: 'Please choose a location',
        remark57: 'The owner already exists, and the newly registered owner information will be bound to the mobile phone number. Do you want to continue?',
        remark58: 'Please select an operable area',
        remark59: 'No related equipment found in this location',
        remark60: 'Failed in getting elevator floor info',
        remark61: 'Given no access to the elevator, please enter the mailing add.',
        remark62: 'Are you sure to delete the elevator permission at the current location?',
        remark63: 'Are you sure to delete the owner? After deleting the current owner\'s information, all the elevator access and communication address information in the current community will be deleted',
        remark64: 'Please select a currently available community',
        remark65: 'No face data entered',
        remark66: 'Face data has been entered',
        remark67: 'Please enter key words',
        remark68: 'Only supports csv、xlsx、xls format files, please confirm and upload',
        remark69: 'Configure Excel file',
        remark70: 'Please enter the device name, model or manufacturer',
        remark71: 'Please select a community (searchable)',
        remark72: 'Please select a manufacturer (searchable)',
        remark73: 'Please fill in',
        remark74: 'Please select installation location',
        remark75: 'The detailed address includes province, city, district and specific address',
        remark76: 'Note: The current option is used to connect to the platform of local regulatory authorities, if necessary, please fill in',
        remark77: 'Please select the city where the device is located (searchable)',
        remark78: 'Please select elevator type',
        remark79: 'Whether to select the current equipment as the main elevator',
        remark80: 'Please determine the location of the main elevator',
        remark81: 'Please confirm the main elevator',
        remark82: 'Please select a branch (searchable)',
        remark83: 'Please select a maintenance company (searchable)',
        remark84: 'Please select Maintenance director (searchable, multi-choice)',
        remark85: 'Please select Device director (searchable, multi-choice)',
        remark86: 'Please select an AD company (searchable)',
        remark87: 'Mobile(searchable, multiple choices available)',
        remark88: 'Please enter a rough position',
        remark89: 'Please enter any number between 1 and 64',
        remark90: 'Please enter full info',
        remark91: 'Please enter legitimate mobile No.',
        remark92: 'Please select devices required of batch processing',
        remark93: 'Click "confirm" to skip from the current page to the community management page',
        remark94: 'The current device is already in the batch list, please do not operate continuously',
        remark95: 'No followed device added',
        remark96: 'No interface field info set for the current city or company, please contact the administrator',
        remark97: 'Please select the community of device',
        remark98: 'No file selected',
        remark99: 'To ensure consistency in the data structure, please follow the template to the letter!',
        remark100: 'Template for entering registered elevator info in the DianTiYun platform',
        remark101: 'Please enter the search content',
        remark102: 'Please fill in the terminal ID',
        remark103: 'Please select a department',
        remark104: 'Please enter elevator name, fault name, etc',
        remark105: 'Please select a specific month',
        remark106: 'Your recharge order has been successfully created and is being processed by the system.',
        //登录页 login.vue
        login_account: 'Login account',
        mobile_username: 'Phone number or UserName',
        mobile: 'Mobile',
        pwd: "Password",
        pwd_old: 'Old password',
        pwd_new: 'New password',
        confirm_new_pwd: 'Confirm the new password',
        login: "Login",
        forget_pwd: "Forget password",
        captcha: "Captcha",
        get_captcha: "Captcha",
        submit: "Submit",
        back_official_web: "Official website",
        back_login: "Back to login",
        //路由配置 router.js
        monitor: "Monitor",
        err_403: "403-Insufficient permissions",
        err_404: "404-Error",
        err_net: "Unable to access this website",
        err_500: "Server 500 error",
        //home界面 home.vue
        home: 'Home',
        sim_statistics: "Sim card statistics",
        normalCount: "Normal",
        oweCount: "Owe",
        stopCount: "Stop",
        ExpireCount: "Expire",
        all_lift: "All",
        cum_fault: " Faults",
        online_lift: "Online",
        maintenance_lift: "Maintenance",
        fault_num: "Number of failures",
        today_fault: "Today's faults",
        today_running: "Today Running",
        today_add_lift: "Elevators added today",
        online: "Online",

        offline: "Offline",
        online_rate: "Online rate",
        wait_maintained: "Wait maintained",
        maintained: "Maintained",
        device_maintenance: "Equipment maintenance",
        fault_rate: "Fault rate",
        normal: "Normal",
        repair: "Repair",
        finish: "Finish",
        terminal_statistics: "Terminal equipment statistics",
        terminal_app: "DianTiYun App",
        terminal_smart: "Smart screen",
        terminal_face: "Face recognition",
        terminal_new_wcr: "New Wcr",
        terminal_old_wcr: "Old Wcr",
        terminal_wcr: "WCR",
        maintenance_statistics: "Maintenance statistics",
        fault_deal_statistics: "Fault handling statistics",
        //主页面 main.vue
        person_info: "Personal information",
        job_num: "Employee ID",
        position: "Position",
        phone_no: "Phone number",
        e_mail: "E-mail",
        company: "Company",
        department: "Department",
        select: "Select",
        change_pwd: "Change Password",
        log_out: "Log Out",
        wipe_cache: "Wipe Cache",
        //    导航 系统管理
        system_manage: 'System ',
        //用户管理
        user_manage: "User",
        company_structure: 'Company Structure',
        role_manage: "Departmental Role Management",
        add_role: "Add new role",
        username: 'Username',
        username_account: 'Username(Login account)',
        name: 'Name',
        real_name: 'Real name',
        birthday: 'Birthday',
        operation: 'Operation',
        //支付账户管理
        pay_account: 'Payment',
        pay_manage: 'Payment account management',
        recharge: 'Recharge',
        recharge_amount: 'Recharge amount',
        send_sms: 'Send text message to',
        recharge_success: "Recharge success",
        //小区管理
        community: 'Community',
        community_manage: "Community",
        unfold: "Unfold",
        community_name: "Community name",
        region: 'Region',
        region_of: "Region",
        detail_address: "Detailed address",
        address: "Address",
        community_info: "Community Information",
        create_community: "Create Community",
        list_page: 'List page',
        detail_page: 'Detail page',
        report_interval: 'Report interval (seconds)',
        duration: 'Duration (seconds)',
        para_monitor: 'Parameter monitoring',
        //系统设置
        system_setting: 'System Settings',
        system_select: 'System setup Options',
        basic_set: 'Basic settings',
        personal_account: 'Personal account',
        info_set: 'Information settings',
        data_monitor_page: 'Data monitoring page',
        data_monitor_set: 'Data monitoring and other information configuration',
        webRTC_set: 'WebRTC configuration',
        webRTC_related_set: 'WebRTC related configuration',
        app_v_manage: 'App version management',
        dtyApp_v_manage: 'DianTiYun App version management',
        face_v_manage: 'Face recognition version management',
        faceApp_v_manage: 'Face recognition App version management',
        smart_v_manage: 'Smart screen version management',
        smartApp_v_manage: 'Smart screen App version management',
        smartlite_v_manage: 'Smart screen lite version management',
        smartlitApp_v_manage: 'Smart screen lite App version management',
        fault_set: 'Fault settings',
        fault_msg_set: 'Setting of fault warning information',
        aliyun_interface_set: 'Alicloud interface configuration',
        newWcr_v_manage: 'New WCR version management',
        api_set1: 'Local authority API interface access grant field configuration',
        api_set2: 'Configure access grant fields',
        sys_nettrans_server: "Net transparent server configuration",
        current_department: 'Current department',
        upload_avatar: 'Upload avatar',
        upload_success: 'Upload successfully',
        upload_fail: 'Upload failed',
        upload_apk: 'Upload apk',
        upload_img: 'Upload',
        upload: 'Upload',
        all_fault_alarm: 'Select all fault alarms',
        all_sms_alarm: 'Select all WeChat Push alerts',
        package: 'Package',
        package_name: 'Package name',
        package_type: 'Package type',
        month_sub: 'Monthly subscribe',
        superposition: 'Superposition',
        flow_data: 'Data',
        original_price: 'Original price',
        discount_price: 'Discount price',
        package_id: 'Package id',
        list_v: 'Version list',
        set_list: 'Configuration list',
        region_select: 'Pusher label',
        region_no_select: 'No region selected',
        push_type: 'Push mode',
        push_setting: "Push setting",
        push_name: 'Push name',
        push_port: 'Push Port',
        manufacturer: 'Manufacturer',
        select_manufacturer1: 'Select manufacturer',
        select_manufacturer2: 'Select manufacturer(Searchable)',
        push_para: 'Push parameters',
        para_des: 'Parameter description',
        add_filed: 'Add parameter',
        file_des: 'Parameter description',
        add_push: 'Add new push setting',
        fault_name: 'Fault name',
        fault_mean: 'Failure meaning',
        fault_alarm: 'Fault warning',
        send_sms2: 'send messages',
        // 导航 乘梯管理
        take_ladder_manage: 'Take Elevator',
        // 业主管理
        owner_manage: 'Owners',
        add_owner: 'Add Owner',
        build_unit: 'Building unit',
        lift_permission: 'Elevator permission',
        lift_position: 'Elevator position',
        select_floor: 'Choose floor',
        deadline: 'Deadline',
        face_lift: 'Privilege to escalator use by face recognition',
        face_collected: 'Faces data collected',
        face_no_collect: 'Face data collected',
        property_manage: 'Property management',
        ordinary_owner: 'Ordinary owner',
        lift_no_permission: 'No elevator use privilege',
        entry_time: 'Entry time',
        authorize: 'Authorization',
        authorize_success: 'Authorization succeeded',
        authorize_fail: 'Authorization failed',
        give_lift: 'Grant elevator use privilege',
        owner_lift: "Owner's access to elevators",
        add_address: 'Add address',
        add_new_address: 'Add new address',
        community_list: 'Cell list',
        //已删钥匙
        deleted_key: "Deletion Keys",
        deleted_keys: 'List of deleted keys',
        bound_lift: 'Bound elevator',
        key_floor: 'Floor',
        delete_time: 'Delete time',
        key_owner: "Owner's name",
        // 导航 设备管理
        device_manage: 'Equipment',
        //设备列表
        device_list: 'Devices',
        remove_device_list: "Delete devices",
        my_focus: 'My focus',
        device_monitor: 'Monitor',
        map_location: 'Map',
        back_devices: 'Back to device list',
        batch_import: 'Bulk Import',
        filter: 'Filter',
        filter_lift: 'Screening elevator',
        elevator_name: 'Name',
        device_model: 'Device model',
        device_type: 'Type',
        device_number: 'Factory number',
        terminal_id: 'Terminal ID',
        batch_operation: 'Bulk operation',
        add_device: 'Add device',
        batch_edit: 'Bulk modification',
        location: 'Location',
        set_excel: 'Excel configuration options',
        down_excel: 'Download form template',
        select_bound_lift: 'Choose to bind the real elevator',
        virtual_lift_id: 'Virtual elevator terminal ID',
        total_floor: 'Total  floor',
        floor: 'Floor',
        positive_floor: 'Positive',
        negative_floor: 'Negative',
        floor_editor: 'Floor editor',
        through_door: 'Through door',
        manual_door: 'Manual Door',
        remote_sync: 'Remote synchronization',
        select_push_city: 'Select push platform',
        lift_type: 'Lift type',
        lift_id: 'Elevator ID',
        lift_mode: 'Elevator mode',
        rated_speed: 'rated speed(m/s)',
        rated_load: 'rated load(kg)',
        main_lift: 'Main elevator',
        lift: 'Elevator',
        virtual_lift: 'Virtual elevator',
        get_coordinates: 'Coordinates',
        latitude: 'Latitude',
        longitude: 'Longitude',
        select_location: 'Select location',
        face_terminal_id: 'Face recognition terminal id',
        manufacturer_branch: 'Manufacturer branch',
        mt_company: 'Maintenance company',
        mt_person: 'Maintenance personnel',
        add_maintenance: 'Add maintenance',
        principal: 'Principal',
        add_principal: 'Add principal',
        terminal: 'Terminal',
        ad_company: 'AD company',
        alarm_mobile: 'Fault reporter',
        alarm_description: 'WeChat Push Alarm Description',
        add_alarm_mobile: 'Create a new fault reporter',
        sms_count: 'Number of WeChat Push sent',// 阿里云
        sms_limit: 'WeChat Push upper limit',   // 阿里云
        sms_enable: 'WeChat Push switch',       // 阿里云
        sms_enable_0: 'Disable',
        sms_enable_1: 'Chinese WeChat Push',
        sms_enable_2: 'China and overseas',
        add_capacity: 'Additional capacity',
        select_all: 'Select all',
        unbound: 'Unbound ',
        batch_edit_info: 'Modify device information in bulk',
        select_position: 'Position calibration',
        current_longitude: 'Longitude of current location',
        current_latitude: 'Latitude of current location',
        selected_lifts: 'List of elevators selected',
        clear: 'Clear',
        lift_info: 'Elevator information',
        device_state: 'Elevator status',
        terminal_type: 'Terminal type',
        lift_name: 'Elevator name',
        device_unique_id: 'Unique job No. of device',
        lift_factory: 'Elevator factory',
        dty_model: 'DianTiYun test template',
        code_model: '(Manufacturer definition)',
        lift_type1: 'Traction and forced drive elevator',
        lift_type2: 'Cargo elevator',
        lift_type3: 'Hydraulic drive elevator',
        lift_type4: 'Escalators and moving walks',
        video_monitor: 'Video monitoring',
        scan_lift: 'Scan code to take the elevator',
        video_call: 'Video call',
        click_help: 'One Touch SOS',
        video_ad: 'Video ad',
        //********************************************************************************
        terminal_operation_list: 'Terminal operation list',
        fault_statistics: 'Failure statistic',
        sendSync: 'Sync floor',
        get_real_time_param: 'Get real-time parameter',
        real_time_param: 'Real-time parameter',
        restart_APP: "Restart APP",
        read_param: 'Read terminal',
        read_setting_file: "Read setting",
        smart_screen_param: 'Screen parameter',
        sim_query: 'SIM-card query',
        check_face_version: 'Check face version',
        check_screen_version: 'Check terminal version',
        down_ladder_code: 'Download elevator code',
        pusher_log: 'Push logs',
        Real_time_status: 'Real-time status',
        history_monitor: 'History monitor',
        remote_file: 'Remote file',
        driver: 'Driver',
        special: 'Special',
        fire: 'Fire',
        fire_start: 'Fire initial state',
        Lock_ladder: 'Lock the ladder',
        fault: "Fault",
        scram_loop: 'Scram loop',
        door_lock_loop: 'Door lock loop',
        overload: 'Overload',
        CAN_fault: 'CAN Fault',
        blackout_emergency: 'Power cut emergency',
        earthquake: 'Earthquake',
        basic_function: 'Basic function',
        data_monitor: 'Data monitoring',
        not_configed: 'Unconfigured',
        extend_functionality: 'Extensive function',
        remote_operate: 'Remote control',
        remote_lock_ladder: 'Parking',
        remote_unlock_ladder: 'Unlock',
        remote_unParking: 'Parking',
        remote_stop: 'Stop ',
        remove_stop: 'Restart',
        remote_down: 'Landing',
        remote_update_pwd: 'Update password cycle',
        password_cycle: 'Password',
        remote_reset: 'Reset',
        device_param: 'Equipment parameters',
        main_board_param: 'Mainboard',
        extension_data: 'Extension',
        outbound_situation: 'Outbound call',
        in_select_case: 'In selected cases',
        in_select: 'In Select',
        out_select: 'Out Select',
        up_select: 'Up Select',
        down_select: 'Down Select',
        alert_warn: 'The Device is not bound to the terminal, or it is offline',
        simulation: 'Simulation',
        video: 'Video',
        stream_m3u8: 'm3u8 Stream',
        item_name: 'Project name',
        device_address: 'Equipment location',
        no_terminal_id: 'Unbound terminal',
        current_fault_record: 'Current equipment failure log',
        return_table: 'Return to the Table',
        change_chart: 'Switch to the chart',
        note: 'Note',
        loading1: 'Remote loading of operating parameters...',
        loading2: 'Connecting terminal...',
        terminal_param: 'The terminal parameters',
        param_list: 'Parameter list',
        return_param_content: 'Returns the parameter',
        history_file: 'List of historical surveillance videos',
        select_time: 'Select start time and end time',
        one_download: 'One-click download',
        new_psw_cycle: 'New password cycle',
        card_from: 'Sim from',
        bind_date: 'Binding date',
        activation_date: 'Activation date',
        open_card: 'Card activating date',
        flow_expire: 'Deadline',
        pay_date: 'Last payment time',
        next_pay_date: 'Next payment time',
        flow_total: 'Total Traffic',
        flow_used: 'Traffic Used',
        read: 'read',
        program_version: 'Program version',
        param_version: 'Parameter version',
        configuration_file: 'Configuration file',
        main_board_param_config: 'Mainboard configuration',
        statistics: 'statistics',
        total_number: 'Total operation times',
        total_time: 'Total running times',
        total_power: 'Total operating energy consumption',
        total_opend: 'Total number of running doors',
        floors_show: 'Floor display',
        protocol_version: 'Protocol version',
        file_name: 'File name',
        download_status: 'Download status',
        file_size: 'File size',
        monitor_time: 'Monitoring time',
        remove: 'remove',
        is_delete: 'Are you sure to delete this record?',
        file_is_download: 'This file is being downloaded and cannot be performed',
        fault_id: 'Fault ID',
        fault_param: "Fault parameters",
        sequence: 'sequence',
        param_name: 'Parameter name',
        param_value: 'Parameter value',
        remark107: 'The elevator is not bound to the terminal or is under offline state',
        remark108: 'Failed to connect to the terminal',
        remark109: 'Current device is in a monitored state and cannot perform this operation！',
        remark110: 'Download data not selected',
        remark111: 'Are you sure you want to download these?',
        remark112: 'datas',
        remark113: 'Virtual elevator refuse to perform the operation',
        remark114: 'Please enter your login password',
        remark115: 'The command requires your login password',
        remark116: 'Please enter the parameters you want to change',
        remark117: 'Please select the instruction to be executed',
        cancel_command: 'Cancel the order',
        reset: 'Reset',
        restor_reset: 'Restore factory setting and reset',
        save_param: 'Save the parameters',
        save_reset: 'Save the parameters and reset',
        enter_level1: 'Enter security level 1',
        enter_level2: 'Enter security level 2',
        sended_command: 'Instruction sent',
        remark118: 'Password cannot be empty',
        remark119: 'Please fill in the password cycle month',
        remark120: 'Failed to perform the operation for historical files are being downloaded',
        remark121: 'Search content cannot be empty',
        remark122: 'Failed to load data',
        remark123: 'Failed to obtain elevator operating parameters within the time limit',
        remark124: 'Failed, please try again',
        remark125: 'Selected date cannot be empty！',
        remark126: 'Get a timeout',
        remark127: 'Failed to connect to the service',
        remark128: 'Downloading...',
        remark129: 'Current device is not bound to a face terminal device',
        remark130: 'Failed to connect the terminal within the time limit',
        remark131: 'Terminal connection failed',
        remark132: 'Unknown',
        remark133: 'Are you sure to restart the APP inside the current terminal device？',
        remark134: 'Restart the success',
        remark135: 'Instruction failed to send. Please try again',
        remark136: 'Mainboard failed to return data within the time limit',
        remark137: 'Reading data',
        remark138: 'Failed to read data',
        unknown_fault: 'Unknown fault',
        door_lock_loop1: "Door lock circuit 1",
        scram_loop1: "Emergency Stop Loop 1",
        door_area: "Door Zone",
        door_area1: "Door Zone 1",
        door_area2: "Door Zone 2",
        converter_fault: "Inverter Fault",
        KMC: "KMC",
        KDY: "KDY",
        opend_brake: "Opened",
        inverter_run: "Frequency converter operating",
        inverter_enable: "Frequency converter enabled",
        KMC_output: "KMC Output",
        KDY_output: "KDY Output",
        door_area_up: "Up Door Zone",
        door_area_down: "Down Door Zone",
        station_broadcast: "Stops Signal",
        run_down: "Down",
        run_up: "Up",
        running: "Running",
        running1: "Running 1",
        front_door_opened: "Front Door Open In Place",
        front_door_opening: "Front Door Open",
        front_door_closed: "Front Door Close In Place",
        front_door_closing: "Front Door Close",
        front_light_curtains: "Front Door Screen",
        front_touch_board: "Front Door Contact",
        back_door_opened: "Back Door Open In Place",
        back_door_opening: "Back Door Open",
        back_door_closed: "Back Door Close In Place",
        back_door_closing: "Back Door Close",
        back_light_curtains: "Back Door Screen",
        back_touch_board: "Back Door Contact",
        load_less: "Lightload",
        load_more: "Overloading",
        load_full: "Full load",
        load_over: "Overload",
        control_multiple: "Group Control",
        control_double: "Parallel",
        endpoint_secondary_up: "End station Of Up-sec",
        endpoint_secondary_down: "End station Of Down-sec",
        endpoint_up: "End station Of Up",
        endpoint_down: "End station Of Down",
        limit_up: "Upper Limit",
        limit_down: "Lower Limit",
        run_status: "Running State", //  1-自动， 2-检修， 3-司机， 4-专用， 5-消防， 6-锁梯， 7-VIP， 8-故障
        // run_model:", //0-正常  1-停电应急（新） 2 - 地震（新）3-消防（新） 4-消防初态（新） 5-专用  6-司机 7-VIP
        floor_current: "Current Floor", //（绝对，最底层为1）
        running_interval: "Operating Curve Interval", // 0-停止， 1-加速， 2-稳速， 3-制动， 4-爬行， 5-维持零速
        zero_speed: "Zero Velocity",
        change_speed_mark: "In Speed",
        curve_change_speed: "Change Speed Curve",
        change_direction_openid: "Reversing Door",
        running_speed: "Running Speed", //（m/s）
        lift_status: 'State of elevator',
        stop: 'Stop',
        safety_circuit: 'Safety circuit',
        closed: 'Closed',
        break: 'Break',
        flat_signal: 'Flat signal',
        effective: 'Effective',
        no_effective: 'Invalidation',
        shaft_switch: 'Shaft switch',
        cage_load: 'Cage load (weighing)',
        digital_cage: "Digital cage weighing module reading --% (display when the percentage is not 0)",
        front_signal: 'Front signal',
        back_signal: 'Back door signal',
        door_opened: 'Door fully opened',
        door_closed: 'Door fully closed',
        safety_light_curtain: 'Safety light curtain',
        security_contact: 'Security contact',
        open_door_instruction: 'Opening instruction',
        close_door_instruction: 'Closing instructions',
        select_signal_ab: "Optional signal :(only Numbers with answer signs are displayed, absolute floors)",
        remark139: "Note that if the 'Through door' is selected, the total floor n+1~2n is selected for the back door",
        remark140: "Note that if the 'Through door' is selected, calls above 32 are backdoor calls",
        remark141: "Note that if the 'Through Door' is selected, a down call greater than 32 is a back door down call",
        remark142: "Upcall signal :(only Numbers with answer signs are displayed, absolute floors)",
        remark143: "Downcall signal :(only the number with the answer sign is displayed, absolute floor)",
        smart_screen_title: "Cloud smart screen management interface",
        end_time: 'End time',
        plays: 'Plays',
        add_video: 'Add video',
        edit_subtitles: 'Edit subtitles',
        select_sound: 'Select sound effect',
        direction_wind: 'Direction',
        wind: 'Wind',
        temperature: 'Temperature',
        level: 'Level',
        volume: 'Volume',
        system_volume: 'System volume',
        media_volume: 'Media volume',
        station_volume: 'Station volume',
        current_brightness: "Current brightness",
        brightness_control: 'Brightness control',
        open_volume: 'Door opening sound',
        close_volume: 'Door closing sound',
        floor_volume: "Leving sound",
        scrolling_speed: 'Subtitle scrolling speed',
        next: 'Next',
        sync_msg_fail: "Failed to send synchronous messages",
        no_update_file: 'Configuration files not modified',
        no_set_parameters: 'Videos without preset parameters exist',
        remark144: 'Elevator standard expiration time is not set',
        remote_sync_data: "Remote data being synchronized ",
        remark145: "Please select the expiration time of scroll caption",
        remark146: "The expiration time cannot be empty",
        remark147: "The file format is incorrect！",
        remark148: ' Before uploading audio files, make sure that the file name is a real floor and the files should be uploaded in the following format: File name corresponding to the first floor: 1. mp3',
        remark149: "Only positive integers between 1 and 5 can be entered",
        remark150: "The scrolling speed of caption could only be an integer from 1 to 10",
        Mon: 'Mon',
        Tue: 'Tue',
        Wed: 'Wed',
        Thu: 'Thu',
        Fri: 'Fri',
        Sat: 'Sat',
        Sun: 'Sun',
        remark151: 'Remote upgrade version failed',
        remark152: 'Remote upgrade version success',
        error: 'error',
        in: 'in',
        occur: 'occur',
        remark153: 'fault',
        remark154: 'Please pay attention and deal with it',
        lift_fault: 'Elevator fault',
        fault_time: 'Fault time',
        remark155: "The device is in distress and cannot monitor or pull files",
        remark156: "The current device is in a monitored state and cannot pull the file",
        remark157: "The current device is in the file download state and cannot be monitored",
        remark158: 'Current device version',
        remark159: 'The latest version is',
        remark160: 'Upgrade to the latest version?',
        remark161: 'Message requiring for version upgrade failed to be sent',
        remark162: 'Terminal remote upgrade in progress...',
        remark163: 'The mainboard parameter failed to return parameters, please try again',
        remark164: 'Failed to read parameters. Please try again',
        agree: 'Agree',
        focus: 'Focus',
        remark165: 'Click to unfollow',
        remark166: 'Modify successfully',
        remark167: 'Clear successfully',
        remark168: 'Make sure to delete the company?',
        remark169: 'Make sure to delete the depart?',
        remark170: 'Delete rejected for the company has affiliated members',
        remark171: 'Delete rejected for the department has affiliated members',
        remark172: 'Elevators with opposite door does not support buildings with over 32 floors',
        remark173: 'Focus on success',
        remark174: 'Return to the website',
        remark175: 'Return home page',
        remark176: 'Back',
        remark177: ' 404-Page not exist',
        remark178: '403-Insufficient permissions',
        remark179: '500-Server error',
        remark180: 'Unable to connect to server',
        remark181: 'Try running the network diagnostics',
        remark182: 'Functional development',
        remark183: 'Password has been changed, please login again',
        remark184: 'Change floor information, need to be synchronized to the elevator terminal, please select the synchronization mode',
        remark185: "Currentdevice",
        remark186: "Synchronize all terminals under the ownership certificate",
        remark187: 'Instruction send successfully',
        company_logo: "Company logo",
        password: 'password',
        confirm_password: 'confirm password',
        remark188: 'Current program version number is none',
        remark189: 'Current parameter version number is none',
        remark190: 'Write parameter cannot be null',
        remark191: 'Write to successful',
        remark192: 'Note: The pixel size of the uploaded file should be 207 * 40!',
        remark193: "Fault alarm person can fill in 2 digits at most!",
        remark194: "no setting",
        remark195: 'SIM card not found',
        remark197: 'Please add specific configuration',
        remark198: 'Special authority selection of department',
        no_focus: 'Cancel the attention',
        click_focus: 'Click on the focus',
        about_expire: 'Due to expire',
        out_of_traffic: 'Traffic is about to run out',
        no_datas: 'No data',
        no_datas_curve: "No data,or files is losed",
        private_role: "Private roles",
        directions: 'instructions',
        dty_platform: 'DianTiYun platform',
        operation_manual: "Platform Operation manual",
        role_res_instructions: 'Instructions on platform user and permission management',
        terminal_operation_manual: "Smart screen terminal operation manual",
        face_operation_manual: "Face recognition terminal operation manual",
        app_operation_manual: "App operation manual",
        Login_failure: "Login failure",
        login_expired: 'Your login has expired or your account has been logged in at another place. Please check account security and log in again.',
        no_permission: "No access rights, please contact enterprise administrator",
        chooseCompany: 'Select the company to continue operating',
        platform_res: 'Platform resources',
        app_res: "APP resources",
        dtzj_res: "DianTiZhuanJia resources",
        //终端列表
        terminal_list: 'Terminals',
        terminal_manage: 'Terminal management',
        yd_bound: 'Binding terminal',
        terminal_identity: 'Identity',
        terminal_account: 'Account',
        terminal_pwd: 'Password',
        yd_unique_code: 'Unique code',
        yd_id_add: 'Input unique id',
        input: 'Input',
        no_connect: 'Not connected',
        wired_network: ' Wired network ',
        network: 'Network',
        create_time: 'Create time',
        click_copy_pwd: 'Copy password',
        update_time: 'Update time',
        print: 'Print',
        qr_code: 'QR code',
        terminal_info: 'Terminal info',
        copy_info: 'Copied to clipboard',
        //故障列表
        fault_list: 'Faults',
        fault_month: 'Select the month of failure(Latest three years)',
        untreated: 'Unprocessed',
        processed: 'Processed',
        fault_des: 'Failure description',
        fault_code: 'Fault No',
        fault_no: 'Fault No',
        fault_explanation: 'Failure explanation',
        resume: 'resume',
        history_delete: 'History Delete',
        resume_condition: 'Restore conditions',
        fault_solution: 'Treatment options',
        fault_state: 'Fault state',
        device_info: 'Device info',
        install_location: 'Installation location',
        device_id: 'Device Id',
        terminal_number: 'Terminal number',
        alerter: 'Fault reporter',
        lift_device: 'Elevator No.',
        fault_floor: 'Floor at the time of failure',
        occur_time: 'Time of occurrence',
        handle_time: 'Handle time',
        state_display: 'Status Display',
        state_para: 'State parameter',
        auto: 'Auto',
        //sim卡列表
        sim_list: 'SIM Card',
        sim_manage: 'SIM card management',
        sim_info: 'SIM Card information',
        pay: 'Pay',
        order: 'Order',
        import: 'Import',
        add_batch: 'Add batch processing',
        operator: 'Operator',
        china_mobile: 'China mobile',
        card_state: 'Card status',
        net_type: 'Network Type',
        card_open_time: 'Activation time',
        card_end_time: 'Deadline',
        effective_time: 'Effective time',
        no_package_msg: 'No package information',
        ali_cloud: 'Alibaba Cloud',
        inactivated: 'Inactivated',
        arrears: 'Arrears',
        out_service: 'Out of service',
        account_cancel: 'Account cancellation',
        will_expire: 'About to expire',
        package_will_out: 'Package traffic is running out',
        package_will_out2: 'Packages are about to run out and expire',
        order_created: 'Order created',
        write_off_time: 'Logout time',
        package_end_time: 'Monitor expiry time',
        detail: 'Detail',
        number: 'Number',
        // 导航 开发调试
        development: "Dev",
        res_manage: 'Resources',
        server_exception: 'Server Exception',
        terminal_exception: "Terminal Exception",
        crash_log: 'Crash Log',
        //使用说明
        explain: 'Instructions',
        unknown_location: "Unknown Location",
        unset_elevator_address: "Elevator address field not set",
        address_parsing_error: "Address parsing error",
        //服务端响应,错误码
        1: "Unknow Error",
        401: "Not Login",
        402: "Your account login is abnormal, please login again",
        403: "Account login has expired, please login again",
        413: "The password is too simple, please reset it",
        414: "Account information does not match, no permission to perform this operation",
        4011: 'User not exists',
        4012: 'Username Or Password Is Error',
        4013: 'The user password must contain at least one digit, uppercase and lowercase letters, and special characters（!、@、#、$、%、^、&、*）',
        4021: "Deletion Failed. The Current User Has Been Deleted",
        4022: "Delete failed",
        4023: "Update failed",
        4024: "The New Password Does Not Match The Old One. Please Re-enter It",
        4025: "update Failed. The Current User Does Not Exist",
        4026: "The phone number already exists",
        4027: "The username already exists",
        4031: 'No bound elevator found',
        4032: "Please select an operable community",
        4033: "The current owner has been deleted or does not exist",
        4035: "Authorization failed",
        4037: "Renewal failed.",
        4039: 'Operation failed, please check whether the current key has been deleted',
        4041: "Current device already saved",
        4042: "Current device not saved",
        4043: "The bound terminal already exists",
        4044: 'Failed to add',
        4045: "deletion failed,The current device has been deleted",
        4046: "Parameter error, command sending failed",
        4047: "Wrong user password, command sending failed",
        4048: "File error",
        4049: "Floors can only be Numbers",
        4050: "Bound terminal exists in the file",
        4061: "The terminal does not exist",
        4062: "Unique ID for current device already exists",
        4071: 'Request error, please make sure the request is made through a legitimate route.',
        4072: 'Your company has not been authorized for payment with DianTiYun account, please check with the system administrator before operation',
        4073: 'Your company account balance is insufficient',
        4074: 'You are not the designated payment account operator of the current operating company, please change the designated account or check with the system administrator for top-up',
        4001: 'Parameter error',
        4081: 'The maximum number of sending has been reached for today, please try again tomorrow',
        4082: 'Sending too frequent, please try again 60s later',
        4084: 'Failed to get captcha',
        4085: 'The user does not exist or the verification code is invalid',
        4086: 'Verification code error',
        4087: 'Verification code expiration',
        4088: 'Current operating company is not selected',
        4090: 'There are subordinates in the current department or company, which cannot be deleted',
        "-1": 'An unknown error',
        4091: 'The face recognition terminal ID has been bound to another device',
        4092: 'The current device is not queried',
        4093: 'The current user does not exist on the iecs platform and cannot add an elevator. Please do this after creating an account in iecs!',
        4094: 'add failed! The current BS number has been registered',
        4095: 'IMSI and BS numbers do not match',
        4096: 'IMSI number already exists',
        4097: 'Too many requests, please try again later',
        4098: "The phone number format is incorrect",
        4099: "Incorrect email format",
        4100: "Frequency too fast, please continue sending in 60 seconds",
        4101: "Email already exists",
        4102: "Parameter error, please enter the correct verification code",
        4103: "Parameter error, missing code",
        4104: "No record found for the corresponding code!",
        4105: "The account and key are the same as the original account and key",
        4106: "Failed to update data",
        4201: "Elevator name is a required field",
        4202: "The format of the maintenance worker field content is incorrect",
        4203: "Warning: The format of the field content for everyone is incorrect",
        4204: "There are already bound SIM card ICCIDs in the file",
        4205: "Iccd has been bound to another terminal ID",
        4206: "The elevator floor is required and the value range is 1~64",
        4207: "The value range of the community is a positive integer, and it is not recommended to modify this item",
        4208: "The value range of the maintenance company is a positive integer, and it is not recommended to modify this item",
        4209: "The range of the through gate value is 0 or 1, and it is not recommended to modify this item",
        4210: "The range of rated speed values is positive integers or positive decimals",
        4211: "The range of rated load values is positive integers or positive decimals",
        4212: "The maximum string length for manufacturer code is 100",
        4213: "The maximum string length for elevator model is 100",
        4214: "The maximum string length for ICCID is 20",
        4215: "The maximum string length for terminal ID is 16",
        4216: "The maximum string length for device code is 100",
        4217: "The maximum string length for the unique elevator job number is 34",
        4218: "The maximum string length for the brand is 50",
        4219: "Duplicate ICCID input",
        4220: "Duplicate elevator unique job number input",
        4221: "Duplicate terminal ID input",
        4222: "There is an illegal terminal ID in the file, please check",
        4223: "There is an illegal elevator unique job number in the file, please check！",
        4224: "There are illegal phone numbers, please check!",
        4225: "There are duplicate unique job numbers in the file, please check!",
        4226: "Administrator import, please set visible elevator factory fields",
        4227: 'Mobile phone numbers cannot be duplicate within the same company',
        4228: 'Email addresses cannot be duplicate within the same company',
        4229: 'The company does not exist. Please refresh and try again',
        4230: 'The current location has an elevator bound to it, which cannot be deleted',
        4231: 'The company currently operated by oneself cannot be deleted',
        5001: "Terminal Timeout",
        5002: 'Device is offline',
        5003: 'The running data monitoring service has expired',
        5004: 'Device does not exist',
        5005: 'The current device has been restored, please do not operate continuously',
        5006: 'The current terminal does not exist',
        5007: 'The current terminal has been bound and cannot be restored',
        5008: 'Please fill in the username',
        5009: 'Please select a company before proceeding',
        5010: 'The phone number already exists',
        6001: 'Invalid original phone number',
        6002: 'The new phone number is already bound to another WeChat account.',
        6003: 'This phone number is already bound to another WeChat account.',
        6004: 'The interface call in the instruction manual failed.',
        6005: 'Parameter error. Please set the reminder messages for different languages completely',
        push_param_error1: "Please fill in the elevator factory number field",
        push_param_error2: "Please fill in the unified social credit code field of the manufacturer",
        push_param_error3: "Please fill in the elevator registration code field",
        hint1: 'Account can not be empty',
        hint2: "the phone number can't be empty",
        hint3: 'The CAPTCA can not empty',
        hint4: 'WeChat Push sent successfully. Please find it well received.',
        hint5: 'Please create a company',
        type: 'Type',
        role: 'Role',
        bind_community: 'Binding cell',
        contact: 'Contact',
        hint6: 'Push WeChat Push signature application',
        hint7: 'Push WeChat Push signature applications such as :[ Shenyang Blue Light]',
        hint8: 'Binding with elevator manually',
        hint9: 'Enable special permissions',
        hint10: 'Specific department permission',
        web_permission: 'Platform permissions',
        app_permission: 'DianTiYunApp permissions',
        DTZJ_permission: 'DianTiZhuanJiaApp permissions',
        name1: 'Name',
        find_community: 'Search community name',
        click_edit: 'Click edit',
        add_son: 'Add subordinate',
        property: 'Property',
        bind_test: 'Demonstration device bound',
        bind_device: 'Binding device',
        create_company: 'Create company',
        user_info: 'User information',
        add_user: 'Add User',
        role_permission: 'Role and permission',
        role_name: 'Role name',
        bind_permission: 'Binding permissions',
        hint11: 'No operation permission',
        hint12: 'You don\'t have permission to do this',
        create_department: 'Create department',
        hint13: 'Click Enter to add e-mail',
        hint14: 'Enter email please',
        hint15: 'Duplicate email address',
        subcompany: 'Subcompany',
        hint16: 'Whether to delete the user',
        hint17: 'Open Page Fault Tip',
        edit_name: 'Edit name',
        create_type: 'Create type',
        single: 'Single',
        batch: 'Batch',
        batch_add_build: 'Create elevators in batch',
        batch_add_unit: 'Batch creation of units',
        build_pre: 'Building name prefix',
        build_suf: 'Building name suffix',
        hint18: 'Please enter the building number',
        hint19: 'The serial number has been added',
        hint20: 'The ending sequence number cannot be lower than the starting sequence number',
        hint21: 'Please add a custom building number',
        hint22: 'Please fill in the name',
        hint23: 'Such as: A, villa, building...',
        hint24: 'Such as: #, #building, building number...',
        hint25: 'Press Enter to add',
        hint26: 'Such as: U, Unit, A...',
        hint27: 'Such as: unit, door...',
        no_type: 'Serial number type',
        number1: 'Digital',
        letter: 'Letter',
        customize: 'Customize',
        start_no: 'Starting sequence number',
        end_no: 'End sequence number',
        build_no: 'Building number',
        create_build_name: 'Generate building name',
        unit_pre: 'Unit name prefix',
        unit_suf: 'Unit name suffix',
        create_unit_name: 'Generating unit name',
        pre: 'Prefix',
        customize_pre: 'Custom prefix',
        start_floor: 'Start floor',
        end_floor: 'End floor',
        users_floor: 'Number of users per layer',
        delimiter: 'Delimiter',
        user_no_type: 'Type of household serial number',
        create_user_name: 'Generate household name',
        batch_add: 'Batch creation',
        set: 'Set up',
        add_build: 'Add buildings',
        build: 'Build',
        unit: 'Unit',
        tenement: 'Resident',
        add_unit: 'Add units',
        hint28: 'Face recognition enabled',
        hint29: 'Facial recognition disabled',
        hint30: 'Permission of "Scanning to take the elevator" enabled',
        hint31: 'Permission of "Scanning to take the elevator" disabled',
        hint32: 'Choose expiration time',
        the_term: 'Term',
        times: 'Frequency',
        floor_name: 'Floor name',
        unstop: 'unstop',
        month_number: 'Current number of months',
        rename: 'Rename',
        hint33: 'Not modified',
        hint34: 'Whether to delete ',
        trap_persons: 'Trapping statistics',
        hint35: 'Video call in progress, are you sure to close?',
        my_msg: 'My message',
        no_msg: 'No news',
        refuse: 'Refuse',
        notify_msg: 'Notification message',
        sign_application: 'Application for signature approval ',
        hint36: 'Initiate distress events, please respond as soon as possible',
        occur_location: 'Location',
        hint37: 'Click to access the monitor image',
        exception: 'Exception',
        para: 'Parameter',
        manager: 'Manager',
        stack_track: 'The Stack information',
        redis_test: 'Redis test',
        redis_count: 'Redis statistics',
        resource: 'Resource',
        res_delete: 'Delete the Resource',
        res_edit: 'Modify the resource',
        new_subsystem: 'New subsystem',
        new_sibling: 'New sibling',
        copy_suc: 'Copy success',
        hint38: 'Copied to clipboard',
        hint39: 'Are you sure you want to delete？',
        hint40: 'The function is not implemented yet',
        hint41: 'Virtual elevators are not of interest',
        hint42: 'Please determine the current master-slave elevator type',
        hint43: 'The total number of through-gate floors can not be greater than 32',
        hint44: 'The total number of elevator floors shall not be greater than the total number of main elevator floors',
        hint45: 'Statistics of annual data',
        detail_content: 'Details',
        hint46: 'Data loading...',
        dty_explain1: 'DianTiYun platform operation manual.doc',
        dty_explain2: 'Instructions and permission management of DianTiYun platform.docx',
        smart_explain: 'Smart screen operation manual.doc',
        face_explain1: 'Manual of 8-inch face recognition all in one elevator machine.docx',
        face_explain2: 'Manual of 10 inch face recognition all in one elevator machine.docx',
        dty_app_explain: 'DianTinYun app user manual.docx',
        hint47: 'Loading components...',
        page_title: 'Page title',
        window: 'Window',
        renewal: 'Renewal',
        hint48: 'Select the action you want to do',
        entrance_guard: 'Entrance guard',
        hint49: 'Do not add the same name',
        hint50: 'Name not modified',
        hint51: 'Name exists',
        binding: 'Binding',
        binding_suc: 'Binding success',
        cancel_binding_suc: 'Unbound successfully',
        hint52: 'Opening the recharge function',
        account_balance: 'Account balance',
        hint53: 'Refresh the list of principals',
        hint54: 'Fill in the WeChat Push signature and click OK to submit the application automatically.',
        hint55: 'After the approval, the elevator fault WeChat Push push of this elevator factory will carry the signature change. ',
        hint56: 'Authenticated WeChat Push signature',
        hint57: 'The WeChat Push signature was not approved',
        hint58: 'Click Edit again',
        hint59: 'WeChat Push signature is being reviewed',
        hint60: 'Fill in the WeChat Push signature and click "confirm" to submit the application automatically.',
        hint61: 'After the approval, the elevator fault WeChat Push push of this elevator factory will carry the signature change.',
        hint62: 'Company / department',
        depart_num: 'departments',
        hint63: 'Please select the currently operating cell',
        current_fault: 'Current number of faulty equipment',
        sim_over: 'Number of SIM cards to be expired and expired',
        lift_trapped: 'Number of trapped equipment',
        hint64: 'SOS video surveillance',
        hint65: 'WeChat Push enabled',
        up: 'Up',
        down: 'Down',
        queryMaintenance: "query Maintenance",
        addMaintenance: "add Maintenance",
        m_depart: "depart",
        m_user: "user",
        m_date: "date",
        m_type: "type",
        m_content: "content",
        m_remarker: "remarker",
        down_face: "Download Zip",
        push_data: "Push Data",
        push_time: 'Push Time',
        pingtai: 'Website',
        shijian: 'time',
        device_curve_list: "Equipment curve",
        data_statistic: "Data Statistics",
        terminal_id_curve: "Vibration Monitor Terminal",
        search: "Search",
        device_history_curve: 'Device History Curve',
        add_remark: "Add Remark",
        look_remark: 'Read Remark',
        goback: "GoBack",
        maintain_list: 'Maintains',
        health: "health",
        start_time: 'Start',
        final_time: "End",
        last_m_weibao: 'Lasted',
        lift_monitor_end_time: 'Lift End Time',
        show_lift_endtime: "Enable permission for elevator expiration",
        device_expire: 'Device permission is expiration',
        change_community_role: 'Change identity in cell',
        push_filed_setting: "Pusher setting",
        describe: "Describe",
        end_time_device_list: "Expired device list",
        batch_renew: 'Batch renewal',
        city: 'city',
        settings_desc: "Configuration description",
        remove_user: 'Remove User',
        remove_user_mobile: 'Phone Number',
        unassigned_to: 'unbind',
        sync_all: 'Sync All',
        synchronization_part: "Sync Part",
        remote_controls: 'Remote Controls',
        open_close_door: 'Open Close Door',
        call_lift: 'Call Lift',
        front_door: 'Front Door',
        back_door: 'Back Door',
        no_body: 'No body',
        some_body: 'Some body',
        company_info: "Company Info",
        event_list: "Event List",
        event_code: "Event Code",
        gb_event_no: "GB Event Code",
        event_no: "Event Code",
        event_name: "Event Name",
        event_explain: "Event Explain",
        gb_fault_no: "GB Fault Code",
        event_save: "Is event storage enabled",
        set_pwd: "Reset Password",
        pwd_again_not_empty: 'Confirm password cannot be empty',
        new_pwd_set: "New password reset",
        brand: 'brand',
        from_card: 'source',
        auto_unicom: 'Automatic Unicom',
        other: 'other',
        all_factory: 'All Factory',
        IMSI: 'IMSI',
        floor_station_door: 'floor*station*door',
        leave_factory_date: 'date of production',
        throw_in_date: 'Input date',
        next_year_date: 'Next inspection date',
        Delivery: 'Delivery or not',
        CONTRACT: 'Contract No',
        INSTALLATION: 'Installation unit',
        INSTALLATIONMAN: 'Installer',

        INSTALLATIONMANMOBILE: 'Installer telephone',
        CONSUMER: 'User unit',
        USEOCCASION: 'Use occasion',
        OWNER: 'property right',
        PROPERTY: 'Property unit',
        WYRY: 'Property personnel',
        WYDH: 'Property telephone',
        project_name: 'entry name',
        parts_life_settings: 'Component usage configuration',
        parts_name: 'Part Name',
        life_limit: 'Life limit',
        warn_monitor: 'warning monitoring',
        parts_warn_config: 'parts warn config',
        device_qrcode: 'Device Qrcode',
        use_time: 'usage time',
        warn_time: 'Warning time',
        warn_detail: 'Alert details',
        running_time: 'operation hours',
        to_zero: 'To 0',
        change_war_config: 'Change WarnConfig',
        change_deviceInfo_config: 'Change LiftInfo',
        user_list: 'User',
        user_table: 'User List',
        authority: 'Authority',
        visible_device: 'Visible Device',
        add_company: 'Add',
        assigned_to: 'Assigned Device',
        remove_device: 'Unassign',
        BS: 'BS Number',
        band_unband_user: 'bind/unband user',
        band_company: 'Bound company',
        unband_user: 'Unbind user',
        band_user: 'Band User',
        selectuserofdevice: "Select the user to query the elevator list under the name",
        export: 'Export',
        qr_id: 'scanner ID',
        export_fault_record: 'Export',
        //     2024年4月1日·    新增aed功能列表
        aed_list: "AED List",
        aed_fault_list: "AED Fault List",
        device_name: 'Device Name',
        device_desc: 'Device Description',
        pwd_again: "Second confirmation password",
        menu_dtzj: "DianTiZhuanJia",
        version_manage: "Version maintenance",
        data_manage: 'Data maintenance',
        logs_manage: 'Log statistics',
        setting_item: "Setting items",
        data_type: "Data type",
        extract_code: "Extract code",
        help_seekers: "Help seekers",
        seeking_help: "Seeking help",
        upload_time: "Upload time",
        download: "Download",
        message_content: "Message Content",
        version_name: "Version Name",
        publisher: "Publisher",
        publisher_time: "Publisher Time",
        publisher_new: "Release a new version",
        bl6_active: "bl6 Active",
        holding_version: "Holding version",
        mobile_model: "Mobile model",
        mobile_sys: "Mobile sys",

        //     2025年2月5日
        variety: 'Variety',
        variety_type1: "Freight elevator",
        variety_type2: "Traction freight elevator",
        variety_type3: "Compulsory freight elevator",
        variety_type4: "Non machine room freight elevator",
        variety_type5: "Car elevator",
        variety_type6: "Explosion proof freight elevator",
        variety_type7: "Hydraulic Elevator",
        variety_type8: "Hydraulic passenger elevator",
        variety_type9: "Explosion proof hydraulic passenger elevator",
        variety_type10: "Hydraulic freight elevator",
        variety_type11: "Explosion proof hydraulic freight elevator",
        variety_type12: "Miscellaneous elevator",
        variety_type13: "Escalator",
        variety_type14: "Automated pedestrian walkway",
        manufacturing: 'Manufacturing',
        import_agent_name: 'Import Agent Name',
        production_date: 'Production Date',
        installation_name: 'Installation Unit',
        installation_check_date: 'Installation inspection Date',
        renovation_name: 'Renovation unit',
        renovation_check_date: 'Renovation Inspection Date',
        major_repairs_name: 'Major Unit',
        major_repairs_check_date: 'Major Unit Date',
        doors: 'Doors',
        up_rated_speed: 'Rated Speed of Up',
        down_rated_speed: 'Rated Speed of Down',
        mt_type1: 'Rescue trapped people',
        mt_type2: 'Alarm handling',
        mt_type3: 'Maintenance',
        mt_type4: 'Repair',
        mt_type5: 'Detection',
        mt_type6: 'Other',
        opinion: 'Use Unit opinion',
        whole_machine_code: "Whole Machine Code",
        mt_details: "Maintenance Details",
        receive_time: "Dispatch time",
        maintain_num: 'Maintain Code',
        insurance_expire: "Insurance Expire",
        insurance_number: 'Insurance Code',
        insurance_unit: 'Insurance Unit',
        internal_code: 'Internal Code',
        mt_company_hotline: 'Maintenance Hotline',
        equipment_code: 'Equipment Code',
        restore_time: "Restore Time",
        special_mode: 'Independent',
        switch_open: 'Open',
        switch_close: 'Close',
        pusher_config: "Pusher Config",
        add_account: 'Add Account',
        wuhan_pusher_config: 'WuHan Push Config',
        child_account: 'Sub Account',
        batch_set_config: "Batch Access/Cancel Access",
        push_scheme: "Push Scheme",
        doc_explain: "Document Explain",
        doc_upload: "Upload of Document",
        pusher_name: "Pusher Name",
        active_code: 'Active Code',
        operate_user: 'Operater',
        pusher_describe: 'Pusher Describe',
        pusher_account: 'Pusher Account',
        account: 'Account',
        secretKey: 'Secret Key',
        pusher_code: 'Pusher Code',
        relationship_structure: "User relationship structure",
        lift_monitor_config: 'Expiration Monitoring ',
        warn_note: 'Note',
        advanced_permission: 'Advanced',
        all: 'All',
        voice: 'Voice',
        picture: 'Picture',
        feedback: 'Feedback',
        oscilloscope_curve: 'Oscilloscope Curve',
        text: 'Text',
        recorder_data: 'Recorder',
        return_parameters: 'Back Parameters',
        fault_analysis: 'Fault Analysis',
        maintenance_fault: 'Repair faults',
        no_maintenance_fault: 'Non Repair faults',
        APK_type: 'APK Type',
        btn_push_test: 'Communication test',
        delete_bind_terminal: 'Bind terminal',
        btn_resume_device: 'Restore basic data',
        delete_device_record: 'Delete device data',
        resume_bind_terminal: 'Restore the original terminal',
        copy: 'Copy',
        sys_upgrade:'System upgrade prompt',
        readed:'I have read',
        sys_notice_config:'System message notification settings',

        // ------------------------- 其他文字说明 start --------------------------------


        remark199: 'Choose Sync Type',
        remark200: 'Please select end time of lift',
        remark201: 'Fill configuration information',
        remark202: 'The bound terminal ID format is illegal',
        remark203: 'Note: The current template is used for batch import, the registered device is the following configured general information',
        remark204: "Please select the device expiration time",
        remark205: "Please select the device to renew",
        remark206: "Unable to register 2G WCR device. Please visit the IECs official website for registration",
        remark207: "Jump to IECs official website",
        remark208: "The user name can only consist of numbers and letters",
        remark209: 'Whether to choose',
        remark210: 'Visible elevator factory with no equipment configured',
        remark211: 'Unconfigured component alarm monitoring, please go to',
        remark212: 'System setting',
        remark213: 'parts use time to 0',
        remark214: 'Has been alarmed',
        remark215: 'After resetting to 0, the usage time of this part will be calculated from 0 again. Please make sure to perform this operation after replacing this part.',
        remark216: 'Please select the elevator to be allocated',
        remark217: 'Please select which company to assign the elevator to！',
        remark218: 'Are you sure to bind the selected device to the currently selected company？',
        remark219: 'Please select company or user to be assigned ',
        remark220: 'The current device already exists in the selected company, and it is forbidden to redistribute it',
        remark221: 'Please select the elevator to be unbound',
        remark222: 'Are you sure to unbind these devices from the selected company?',
        remark223: 'Please select the company that unbind the device',
        remark224: 'Please select the company that needs to unbind',
        remark225: 'Are you sure to unbind these devices ？',
        remark226: 'The currently logged-in user cannot delete his account',
        remark227: 'Are you sure you want to restore the currently deleted device ?',
        remark228: 'Please select the user to be bound(searchable)',
        remark229: 'No user to be bound is selected',
        remark230: 'The current device is not bound to a user',
        remark231: 'No other users are bound',
        remark232: 'Are you sure to export the data?, The overall export time is slow,Please be patient.',
        remark233: "Please save the file as Microsoft Excel 97-2003 ",
        remark234: "Please enter the device name",
        remark235: "Please enter a device description",
        remark236: "Please enter the device model",
        remark237: "Please enter the device brand",
        remark238: "The device name cannot be empty",
        remark239: "Click the Get Verification Code button to complete the verification module below to obtain the WeChat Push verification code",
        remark240: "Elevator Cloud reminds you to bind your phone number or email address and enhance password complexity before continuing with the operation",
        remark241: "The daily password for the QR code can be between 6 and 30 characters in length, and must include numbers, uppercase and lowercase letters, and special characters (!, @, #, $, %, ^, &, *, _). Spaces and Chinese characters are not allowed.",
        remark242: "Please fill in the correct m3u8 format address for the video stream",
        remark243: "Please select the record to delete!",
        remark244: "Version number must be greater than 0!",
        remark245: "The file size must be greater than 0!",
        remark246: "The user's phone number or email must be filled in with one",
        remark247: 'The platform\'s docking information will be continuously updated according to changes in the docking functions. Please refer to this location for the latest version',
        remark248: 'Please enter key information such as elevator name, terminal number, model, location, and elevator serial number',
        remark249: 'Please select the devices that need to be connected or disconnected',
        remark250: 'Please select the access plan required',
        remark251: 'Please enter the name of the push platform',
        remark252: 'Do you want to query non null value accounts',
        remark253: "Please select APK type",
// ----------------------------操作说明 start ----------------------------
    explain1: 'The company type has independent permissions, while the Department type has all permissions of the parent company.',
    explain2: 'The current option displays all visible role information. Child companies can only inherit the roles of parent companies, and departments can select different roles.',
    explain3: 'When this option is selected, all elevators of the company currently created can only be seen through the "bind equipment" function.',
    explain4: 'If the current role permissions do not meet the requirements, you can check this option to add other additional permissions.',
    explain5: 'Platform permission refers to the elevator cloud platform, and app permission refers to the elevator cloud app. Check the corresponding permission name to add this permission for the current role.',
    explain6: 'Whether the new user is given the permission to configure the elevator expiration time.',
    explain7: 'When assigning a QR code key to the owner, the maximum number of times the key can be refreshed on the same day. If this value is exceeded, the QR code key cannot be obtained on the same day.',
    explain8: 'The default expiration time of the elevator is 12 months. After expiration, the elevator status will be displayed offline, and the administrator can change the expiration date of the equipment.',
    explain9: 'Set the current user as the current cell administrator. The cell administrator has the ability to connect to the terminal device and export user data through the "elevator cloud ride elevator" applet.',
    explain10: 'Edit the floor display information. The specific floor display information is determined according to the total floor added. Total floor = positive floor + negative floor.',
    explain11: 'Brand of elevator equipment.',
    explain12: 'This elevator is visible to the selected manufacturer.',
    explain13: 'This elevator can be seen by the selected manufacturer and its subsidiaries.',
    explain14: 'Batch modification only supports multiple devices to modify the same information at the same time.',
    explain15: 'Enter the terminal information through the unique equipment job number and terminal ID.',
    explain16: 'This field can be used as a partial push platform push configuration field. This field and the registration code in the push platform configuration can be selected and filled in.',
    explain17: 'After the manual door option is turned on, the extended data function in the elevator details cannot obtain the information of the number of times of opening and closing the door.',
    explain18: "Starting from June 23, 2025, a maximum of two fault alarm personnel can be configured, and the original configuration before this date will remain unchanged!",
    explain19: "Fault WeChat Push sending rules: The same device with the same fault can only be sent once on the same day, and the same device can only send fault reminder WeChat Push up to 3 times a day.No limit on the number of transmissions for trapped person faults.",
    explain20: "The fault reminder message can be unsubscribed. After unsubscribing, you will no longer be able to receive the fault reminder message",
    explain21: "The WeChat Push function is enabled by default in China. If disabled, the Alibaba Cloud WeChat Push service interface will not be used. When used in conjunction with the WeChat Push limit, a single elevator WeChat Push reminder sending limit can be set.",
    explain22: "The WeChat Push limit is the maximum number of WeChat Push reminders per elevator, and when used in conjunction with the WeChat Push function, if the WeChat Push function is enabled and the limit value is set, no more reminder messages will be sent once the WeChat Push reminder reaches this value.",
    explain23: "WeChat Push service providers will impose restrictions on the sending frequency of the same number, with a maximum of 50 messages per minute, 50 messages per hour, and 50 messages per natural day.",
    explain24: "For special fault codes: 2 (scraping of door lock during elevator operation), 37 (shaking of running contactor during opening operation), send them once every three times a day for the same elevator, and then no longer send them.Fault on the 31st will never send text messages. The 26th malfunction will be sent once a day.",
    explain25: 'Note: Starting from January 19, 2026, please fill in your phone number for registering a domestic account, and your email for registering an overseas account',
// ----------------------------操作说明 end ----------------------------

    //微信服务号
    product_manual: 'Product Manual',
    machine_manual: 'Machine Manual',
    document_search: 'Search by document name',
    access_count: 'Number of accesses',
    document_size: 'Size of documents',
    document_number: 'Number of documents',
    view_document: 'View Document',
    preview: 'Preview',
    previous_page: 'Previous Page',
    next_page: 'Next Page',
    fault_query: 'Fault Query',
    err_code: 'Fault code',
    err_child: 'Fault Subcode',
    err_solution: 'Solution method',
    err_meaning: 'Fault Meaning',
    bind_mobile: 'Bind mobile number',
    change_mobile: 'Change mobile number',
    account_binding: 'Account Binding',
    old_mobile: 'Old Mobile',
    new_mobile: 'New Mobile',
    same_mobile: 'The phone numbers are consistent',
    bind_success: 'Bind success',
    bind_tip: 'The account you have bound does not exist. Please rebind',
    dty_gzh:'WeChat Official Account',
}